import {
  DataFetcher,
  PriorityConfig,
  useGrpcRequest,
} from '@aboutyou/data-fetcher';
import {BrandHubPageMetaService_GetBreadcrumbsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/meta/service.grpc.lazy';
import {useIsMultiBrand} from '@aboutyou/router';
import React, {FC} from 'react';
import {
  BreadcrumbSkeletons,
  BreadcrumbsView,
} from '../../../features/Breadcrumbs/Breadcrumbs';
import {
  useBrandShopCacheKeyTransformer,
  useBrandShopIdentifier,
} from '../utils/useBrandShopIdentifier';

export const BrandPageBreadcrumbs: FC<PriorityConfig> = ({
  renderingPriority,
}) => {
  return (
    <DataFetcher
      request={useBreadcrumbs()}
      Error={null}
      View={BreadcrumbsView}
      Loading={BreadcrumbSkeletons}
      renderingPriority={renderingPriority}
    />
  );
};

const useBreadcrumbs = () => {
  const brandIdentifier = useBrandShopIdentifier();
  const isMultiBrand = useIsMultiBrand();
  const brandShopCacheKeyTransformer = useBrandShopCacheKeyTransformer();

  return useGrpcRequest(
    BrandHubPageMetaService_GetBreadcrumbsLazy,
    {
      isMultiBrand,
      brand: {
        identifier: brandIdentifier,
      },
    },
    {
      retry: false,
      nonEssential: true,
      transformCacheKey: brandShopCacheKeyTransformer,
    },
  );
};
